// extracted by mini-css-extract-plugin
export default {"default":"CustomButton_default__M7Nul","primary":"CustomButton_primary__HP95U","outline_primary":"CustomButton_outline_primary__OV99Q"};